/**
 * Вычисляет линейный тренд методом наименьших квадратов (OLS).
 * @param points Массив точек {x: timestamp (ms), y: value}
 * @returns {slope, intercept} или null если точек < 2
 */
export const buildTrend = (points: Array<{ x: number; y: number }>) => {
  if (points.length < 2) {
    return null;
  }
  let sumX = 0;
  let sumY = 0;
  let sumXX = 0;
  let sumXY = 0;
  for (const p of points) {
    sumX += p.x;
    sumY += p.y;
    sumXX += p.x * p.x;
    sumXY += p.x * p.y;
  }
  const n = points.length;
  const denom = n * sumXX - sumX * sumX;
  if (denom === 0) {
    return null;
  }
  const slope = (n * sumXY - sumX * sumY) / denom;
  const intercept = (sumY - slope * sumX) / n;

  // Вычисляем стандартное отклонение (σ)
  let sumResiduals = 0;
  for (const p of points) {
    const predicted = intercept + slope * p.x;
    const residual = p.y - predicted;
    sumResiduals += residual * residual;
  }
  const stdDev = Math.sqrt(sumResiduals / n);

  return { slope, intercept, stdDev };
};
